import Exportable from './Exportable';

class Child extends Exportable {
  constructor(args = {}) {
    super();

    this.parentInstance = args.parent;
  }

  /**
   * Pop back up to the parent
   */
  parent(parent) {
    if (parent === undefined) {
      return this.parentInstance;
    }

    this.parentInstance = parent;

    return this;
  }
}

export default Child;
